import { Typography, TypographyProps } from '@mui/material'
import { ReactElement } from 'react'

export const DataGridTypography = (props: TypographyProps): ReactElement => {
  return <Typography component="span" {...props} />
}
